import { autoinject } from 'aurelia-framework';
import { EnvironmentService } from 'app/shared/services/environment-service';
import { fireEvent } from 'app/shared/lib/fire-events';
import { AppSession } from 'app/shared/lib/session/session';
import { modelCodeToResourceKey } from 'app/shared/lib/i18n';

@autoinject()
export class EssUserPanel {

    constructor(
        protected readonly element: Element,
        protected readonly session: AppSession,
        protected readonly env: EnvironmentService) { }

    protected checkIn(): void {
        fireEvent(this.element, 'user-action', { action: 'check-in' });
    }

    protected myAccount(): void {
        fireEvent(this.element, 'user-action', { action: 'my-account' });
    }

    protected logOut(): void {
        fireEvent(this.element, 'user-action', { action: 'log-out', messageKey: 'ui:messages.logOut' });
    }

    protected attachedToKey(attachedToCode: string): string {
        return modelCodeToResourceKey(attachedToCode, { suffix: '$' });
    }
}
